import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-general-info-modal',
    templateUrl: './general-info-modal.component.html',
    styleUrls: ['./general-info-modal.component.scss'],
    standalone: false
})
export class GeneralInfoModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<GeneralInfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string | "Info",
      message: string | "message",
      confirmText: string | "OK"
    }
  ) {}

  ngOnInit() {
  }

  confirm() {
    this.dialogRef.close(this.data);
  }

}
